import { render, staticRenderFns } from "./selectTable.vue?vue&type=template&id=463927ab&scoped=true&"
import script from "./selectTable.vue?vue&type=script&lang=js&"
export * from "./selectTable.vue?vue&type=script&lang=js&"
import style0 from "./selectTable.vue?vue&type=style&index=0&id=463927ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463927ab",
  null
  
)

export default component.exports